module.exports = __webpack_public_path__ + "img/masterclass-sesi-2.644c4070.png";